import { createSelector } from 'reselect';

const selectCache = (state: any) => state.cloCache;

export const selectTopThreeCLO = createSelector(
  selectCache,
  (cache: any) => cache.topThreeCLO
);

export const selectLoadingTopThreeCLO = createSelector(
  selectCache,
  (cache: any) => cache.loadingTopThreeCLO
);

export const selectCLOListing = createSelector(
  selectCache,
  (cache: any) => cache.CLOListing
);

export const selectLoadingCLOListing = createSelector(
  selectCache,
  (cache: any) => cache.loadingCLOListing
);

export const selectCLODetails = createSelector(
  selectCache,
  (cache: any) => cache.CLODetails
);

export const selectLoadingCLODetails = createSelector(
  selectCache,
  (cache: any) => cache.loadingCLODetails
);

export const selectAddingCLOAsFavourite = createSelector(
  selectCache,
  (cache: any) => cache.addingCLOAsFavourite
);

export const selectRemovingCLOAsFavourite = createSelector(
  selectCache,
  (cache: any) => cache.removingCLOAsFavourite
);

export const selectHidingCLO = createSelector(
  selectCache,
  (cache: any) => cache.hidingCLO
);

export const selectUnhidingCLO = createSelector(
  selectCache,
  (cache: any) => cache.unhidingCLO
);

export const selectRefreshTopThreeCLO = createSelector(
  selectCache,
  (cache: any) => cache.refreshCLO
);
